import { Dialog, ExportTableDialog } from "@/ds";
import { SecoesMenu } from "@/shared/components";
import {
  EMBARCACAO_DETAIL_EXPORT_LIST_NAME,
  EMBARCACAO_DETAIL_EXPORT_SCOPE,
} from "./embarcacao-detail-dialog.constants";
import styles from "./embarcacao-detail-dialog.module.scss";
import { EmbarcacaoDetailExportButton } from "./embarcacao-detail-export-button";
import type { EmbarcacaoDetailDialogViewProps } from "./types-embarcacao-detail-dialog";

/** Menu lateral de seções (no mobile, o seletor no topo do corpo) e o corpo rolável com todas elas em sequência. */
export function EmbarcacaoDetailDialogView({
  title,
  isMobile,
  embarcacaoId,
  sections,
  onReauthenticate,
  fechar,
  menu,
  bodyRef,
  propsCorpo,
  exportarSize,
  exportacao,
}: EmbarcacaoDetailDialogViewProps) {
  return (
    <>
      <Dialog
        visible
        onHide={fechar}
        size="xl"
        className="p-dialog-detalhe"
        header={title}
        dismissableMask
        data-testid="embarcacao-detail-dialog"
      >
        <div className={styles.layout}>
          {isMobile ? null : <SecoesMenu {...menu} className={styles.menu} />}

          {/* Visualização vertical única: todas as seções vivem no mesmo corpo rolável. */}
          <div
            className={styles.corpo}
            ref={bodyRef}
            {...propsCorpo}
            data-testid="embarcacao-detail-body"
          >
            {/* Topo do corpo: o "Exportar" do protótipo, à direita; no mobile, o seletor de seções à esquerda dele. */}
            <div className={styles.acoes}>
              {isMobile ? <SecoesMenu {...menu} className={styles.seletor} /> : null}
              {exportacao.podeExportar ? (
                <EmbarcacaoDetailExportButton
                  isExporting={exportacao.exportando}
                  onClick={exportacao.abrirExportacao}
                  size={exportarSize}
                />
              ) : null}
            </div>

            {sections.map(({ id, Component }) => (
              <Component key={id} embarcacaoId={embarcacaoId} onReauthenticate={onReauthenticate} />
            ))}
          </div>
        </div>
      </Dialog>

      {exportacao.exportDialog.isOpen ? (
        <ExportTableDialog
          listName={EMBARCACAO_DETAIL_EXPORT_LIST_NAME}
          scopeDescription={EMBARCACAO_DETAIL_EXPORT_SCOPE}
          isExporting={exportacao.exportDialog.isExporting}
          xlsxLayouts={exportacao.exportDialog.xlsxLayouts}
          onExport={exportacao.exportDialog.exportar}
          onCancel={exportacao.exportDialog.fechar}
        />
      ) : null}
    </>
  );
}
